import { useCountry } from '~/components/Locale/CountryProvider'
import { useSelector } from './hooks'

export function useMarket() {
	const markets = useSelector(s => s.markets)
	const country = useCountry()
	const code = country.iso_code
	const market =
		code === 'EU'
			? markets
					?.filter(m => m.currency === 'EUR')
					.sort((a, b) => b.countries.length - a.countries.length)
					.pop()
			: markets?.find(m => m.countries.includes(code))
	return market
}
